var exports = {
  "G": "x61f99309--3f93af--loader-typing",
  "J": "x61f99309--3f93af--cssload-push",
};

module.exports = exports;
